import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { TICKET_MASSIVE_POSTPONE_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import TicketMassivePostponeInformationResource from './resource/TicketMassivePostponeInformationResource';
import {
  clearTicketPostponeProcess,
  getTicketPostponeProcess,
} from '../../../../actions/reservation/TicketPostponeProcess';

export const TicketMassivePostpone = ({
  breadcrumbs,
  dispatchGetTicketPostponeProcess,
  dispatchClearTicketPostponeProcess,
  match: {
    params: { id: ticketPostponeProcessId },
  },
  loading,
  ticketPostponeProcess,
}) => {
  useLayoutEffect(() => {
    dispatchGetTicketPostponeProcess({ ticketPostponeProcessId });

    return () => dispatchClearTicketPostponeProcess();
  }, []);

  let content;

  if (loading) content = <Loader />;
  else if (ticketPostponeProcess.isEmpty())
    content = <NoDataResource returnPage={TICKET_MASSIVE_POSTPONE_PATH} />;
  else {
    const ticketPostponeProcessJson = ticketPostponeProcess.toJS();

    content = (
      <TicketMassivePostponeInformationResource
        {...ticketPostponeProcessJson}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Postergación Masiva de Boletos"
      content={content}
    />
  );
};

TicketMassivePostpone.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearTicketPostponeProcess: PropTypes.func.isRequired,
  dispatchGetTicketPostponeProcess: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  ticketPostponeProcess: PropTypes.instanceOf(Immutable.Map).isRequired,
};

TicketMassivePostpone.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearTicketPostponeProcess: clearTicketPostponeProcess,
  dispatchGetTicketPostponeProcess: getTicketPostponeProcess,
};

const mapStateToProps = ({ ReservationUnit }) => ({
  breadcrumbs: [
    ...ReservationUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Postergaciones Masiva de Boletos',
      href: TICKET_MASSIVE_POSTPONE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  ticketPostponeProcess: ReservationUnit.TicketPostponeProcess.getIn([
    'current',
    'content',
  ]),
  loading: !ReservationUnit.TicketPostponeProcess.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TicketMassivePostpone);
